import { captureException } from "@sentry/browser";
import { AxiosInstance, AxiosResponse } from "axios";
import { Dispatch } from "redux";
import { showNotification } from "../../notification/actions";
import { REFRESH_PLAN } from "../types";
import { PlanActionTypes } from "../models/planActions";
import { IStateTree } from "../../interfaces";

export default (data: { planId: string }, callback?: (res: AxiosResponse<{ success: true }>) => void) => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.post<{ success: true }>("/refresh-plan", data);
        dispatch({
            type: REFRESH_PLAN,
            payload: { ...res, ...data },
        });
        if (callback) callback(res);
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};